import { ContainerModule } from 'inversify';
import { MessageManager, MessageStrategyTypes, IMessageStrategy, createPlainMessageStrategy } from '@framework/message';
import messageCodes from '@framework/message/messages';
import messageMapping from '@framework/message/Mapper/messageMapping';

export const messageManagerModule: ContainerModule = new ContainerModule(({ bind }) => {
  bind<IMessageStrategy>(MessageStrategyTypes).toDynamicValue(() => {
    return createPlainMessageStrategy(messageCodes, messageMapping);
  });
  bind(MessageManager).toSelf().inSingletonScope();
});
